import moment from 'moment';
import { t } from 'i18next';
import { truncateString } from '../../../helpers/functions';

import { RedditPost } from './types';
import React from 'react';

export const RedditCard = ({
  post: { author, createdAt, id, permalink, title },
}: {
  post: RedditPost;
}) => (
  <div
    key={'reddit-post-' + id}
    className={
      'flex border-grey-10 dark:border-grey-80  shadow-md border-1 rounded-lg p-4 cursor-pointer'
    }
    onClick={() => permalink && window.open(permalink, '_blank')}
  >
    <div className={'block w-full'}>
      <div className={'flex justify-between'}>
        <div className={'flex text-xs text-grey-50 w-7/12'}>
          {t('widget.reddit.postedBy')} u/{author}
        </div>
        <div className={'text-xs text-grey-50 text-right w-5/12'}>
          {moment(createdAt).format('h:mm A - MMM DD YYYY')}
        </div>
      </div>
      <div
        className={
          'mt-4 mb-2 font-semibold max-h-24 overflow-ellipsis overflow-hidden'
        }
      >
        <span className={'text-container'}>{truncateString(title, 160)}</span>
      </div>
    </div>
  </div>
);
